import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'

import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import PageControl from 'designer/component/control/page/InputSearchControl'
import FavoriteControl from 'designer/component/control/favorite/InputSearchControl'

export const PageInputSearchSystem = (props) => (
  <DragElementWrapper {...props}>
    <PageControl {...props} />
  </DragElementWrapper>
)

export const PageInputSearchDisplay = (props) => (
  <ElementWrapper {...props}>
    <PageControl {...props} />
  </ElementWrapper>
)

export const FavoriteInputSearch = (props) => (
  <ElementWrapper {...props}>
    <FavoriteControl {...props} />
  </ElementWrapper>
)

export const inputSearchTester = rankWith(1000, scopeEndsWith('inputSearch'))
